function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable no-unused-expressions */

/* eslint-disable no-mixed-operators */
var Image = /*#__PURE__*/function () {
  function Image() {
    _classCallCheck(this, Image);
  }

  _createClass(Image, null, [{
    key: "init",
    value: function init() {
      Image.timerID = 0;
      Image.initImageZoom();
      Image.initEvents();
    }
  }, {
    key: "initImageZoom",
    value: function initImageZoom() {
      var images = document.querySelectorAll('.form-sidepanel .image');

      _toConsumableArray(images).forEach(function (image, index) {
        var wrapper = image.querySelector('.cmp-image');
        var img = image.querySelector('img');

        if (wrapper && img) {
          img.setAttribute('id', "image_zoom_".concat(index));
          wrapper.style.backgroundImage = "url('".concat(img.getAttribute('src'), "')");
        }
      });
    }
  }, {
    key: "initEvents",
    value: function initEvents() {
      document.addEventListener('mousemove', Image.zoom, false);
      document.addEventListener('touchmove', Image.zoom, false);
    }
  }, {
    key: "zoom",
    value: function zoom(e) {
      if (e.target && e.target.id.includes('image_zoom_')) {
        var zoomer = e.target.parentNode;
        e.target.style.opacity = 0;
        var offsetX;
        var offsetY;
        e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX;
        e.offsetY ? offsetY = e.offsetY : offsetY = e.touches[0].pageY;
        var x = offsetX / zoomer.offsetWidth * 100;
        var y = offsetY / zoomer.offsetHeight * 100;
        zoomer.style.backgroundPosition = "".concat(x, "% ").concat(y, "%");
        zoomer.classList.add('active');
        clearTimeout(Image.timerID);
        Image.timerID = setTimeout(function () {
          e.target.style.opacity = 1;
          zoomer.style.backgroundPosition = '50% 50%';
          zoomer.classList.remove('active');
        }, 100);
      }
    }
  }]);

  return Image;
}();

export default Image;